
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import UmbracoApiService from "@/services/UmbracoApiService";
import CertificadoBeneficiosService from "@/services/CertificadoBeneficiosService";
import TuEstadoCuentaForm from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaForm.vue";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import WsdlService from "@/services/WsdlService";
import TuEstadoCuentaResult from "@/components/Tu_Estado_Cuenta/TuEstadoCuentaResult.vue";
import Swal from "sweetalert2";
import EstadoDeCuentaModel from "@/models/TuEstadoCuenta/TuEstadoCuentaModel";
import FundType from "@/models/WsdlResponses/FundType";
import Axios from "axios";
import User from "@/models/User";
import { Getter } from "vuex-class";
import { CertificadoResponse } from '@/models/CertificadoBeneficios/CertificadoResponse';


@Component({
	components: {
		TuEstadoCuentaForm,
		TuEstadoCuentaResult
	}
})
export default class CertificadoBeneficios extends Vue {
	public isLoading: boolean = false;
	public tipoFondo: Array<FundTypeObj> = [];
    public wsdlService: WsdlService = new WsdlService();
    public umbracoService = new UmbracoApiService();
	public CertificadoBeneficiosService = new CertificadoBeneficiosService();
    public userId: string = this.$store.state.user.cedula;
    public showResult: boolean = false;
	public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
    public labelData = new EstadoDeCuentaModel();
	public afiliado: any = {}
	public saldos: any = {};
	public conceptos: any = {};
	public movimientos: any = {};
	public eDC: any = {};
	public iniDate: string = "";
	public FinDate: string = "";
	public Base64 : string = "";
	public certificateResponse : CertificadoResponse = new CertificadoResponse();
	@Getter("user") user: User;


    constructor() {
        super();
    }
      mounted() {
		  this.getCertificado()
    }
	  async created(){
		  await this.getLabelData();
	}
	public async getLabelData(){
		this.labelData = await this.umbracoService.getCertificadoBeneficios()
	}

	 
 
	public getFormattedDate(date: Date) : string {
		let year = date.getFullYear();

		let month = (1 + date.getMonth()).toString();
		month = month.length > 1 ? month : '0' + month;

		let day = date.getDate().toString();
		day = day.length > 1 ? day : '0' + day;
		
		return day + '/' + month + '/' + year;
	}
	returnHome(){
		window.location.href = GlobalConfig.PORTAL_BASE_URL
	}
	GoActualziarDatos(){
		this.$router.push("/actualizacion-de-datos");
	}
	public async getCertificado(){
		this.showLoadingAlert("Generando certificado");
		var certificate =   await this.CertificadoBeneficiosService.GetCertificado(this.user.cedula).then(resp=>{
			this.certificateResponse = resp.data.entity;
			Swal.close();
		}); 
	}

	public downloadFilePDF(fileName, uri) {
            const dataURI = uri;
            const blob = this.dataURIToBlob(dataURI);
            const url = URL.createObjectURL(blob);
            const blobAnchor = document.createElement('a');
            const dataURIAnchor = document.createElement('a');
            blobAnchor.download = dataURIAnchor.download = fileName;
            blobAnchor.className = 'hidden';
            blobAnchor.href = url;
            dataURIAnchor.href = dataURI;
            document.body.appendChild(blobAnchor);
            blobAnchor.onclick = function () {
                requestAnimationFrame(function () {
                    URL.revokeObjectURL(url);
                    setTimeout(() => blobAnchor.remove(), 300);
                });
            };
            blobAnchor.click();
        }
		public dataURIToBlob(dataURI) {
            const binStr = atob(dataURI),
                len = binStr.length,
                arr = new Uint8Array(len),
                mimeString = 'application/pdf';
            for (let i = 0; i < len; i++) {
                arr[i] = binStr.charCodeAt(i);
            }
            return new Blob([arr], {
                type: mimeString
            });
        }

	  public showLoadingAlert(message: string): void {
        Swal.fire({
            text: message,
            icon: "info",
            timerProgressBar: true,
            onBeforeOpen: () => {
                Swal.showLoading();
            },
            allowOutsideClick: false,
        });
    }

   

}
